import { cacheKey } from '@/constants/cache-key';
import {
	type IApiResponse,
	type IElectoralDivisionMetaDataFormHook,
	type IWardByCode,
	type IWardByIDState,
	type IWardInLGAStates,
	type IWardStates,
} from '@/helpers/types';
import { getCoreQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

const wardApislice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createWard: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/Ward',
				body,
			}),
		}),
		getWard: builder.query<IWardStates, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/Ward${getCoreQuery(paged, ...(query || []))}`,
			}),
		}),
		getWards: builder.query({
			query: (params) => ({ url: '/Ward', params }),
		}),
		getWardById: builder.query<IWardByIDState, { id: string }>({
			query: ({ id }) => ({
				url: `/Ward/${id}`,
			}),
		}),
		getWardByCode: builder.mutation<IWardByCode, { wardCode: string }>({
			query: (body) => ({
				url: '/Ward/code',
				method: 'POST',
				body,
			}),
		}),
		getWardsInLGA: builder.mutation<IWardInLGAStates, { lgaIds: number[] }>({
			query: (body) => ({
				url: '/Ward/getWardsInLga',
				method: 'POST',
				body,
			}),
		}),
		updateWard: builder.mutation({
			query: (body) => ({
				method: 'PUT',
				url: '/Ward/update',
				body,
			}),
		}),
		deleteWardById: builder.mutation<Record<string, any>, { id: string }>({
			query: ({ id }) => ({
				method: 'DELETE',
				url: `/Ward/delete/${id}`,
			}),
		}),
		updateWardMetaData: builder.mutation<IApiResponse, { id: number | string; data: IElectoralDivisionMetaDataFormHook }>({
			query: ({ id, data }) => ({
				method: 'PUT',
				url: `/Ward/updatemetadata/${id}`,
				body: data,
			}),
		}),
	}),
});

export const {
	useCreateWardMutation,
	useDeleteWardByIdMutation,
	useGetWardByCodeMutation,
	useGetWardByIdQuery,
	useLazyGetWardsQuery,
	useGetWardQuery,
	useLazyGetWardQuery,
	useGetWardsInLGAMutation,
	useGetWardsQuery,
	useLazyGetWardByIdQuery,
	useUpdateWardMetaDataMutation,
	useUpdateWardMutation,
} = wardApislice;

export const selectGetWardInLga = wardApislice.endpoints.getWardsInLGA.select({
	fixedCacheKey: cacheKey.GETWARDINLGA,
	requestId: '',
});
